import { useNavigate } from "react-router-dom";
import not_cool from "../../assets/images/capysad.png";

export default function NotCool() {
  const navigate = useNavigate();

  return (
    <div className="notcool-container">
      <img src={not_cool} alt="Página No Disponible" className="notcool-img" />
      <h1>Página No Disponible</h1>
      <p>Lo sentimos, esta página no está disponible en este momento.</p>

      <button className="notcool-btn" onClick={() => navigate("/")}>
        Volver al inicio
      </button>

      <style>{`
        .notcool-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100vh;
          text-align: center;
          background: radial-gradient(circle at center, rgba(0, 0, 0, 0.8) 0%, rgba(20, 20, 20, 0.95) 100%);
          color: #fff;
          font-family: 'Poppins', sans-serif;
          padding: 20px;
        }

        .notcool-img {
          width: 180px;
          max-width: 70%;
          margin-bottom: 25px;
          filter: drop-shadow(0 0 10px rgba(245, 197, 24, 0.6));
          transition: transform 0.3s ease;
        }

        .notcool-img:hover {
          transform: scale(1.05);
        }

        .notcool-container h1 {
          color: #f5c518;
          margin-bottom: 10px;
          font-size: 2rem;
        }

        .notcool-container p {
          font-size: 1.1rem;
          color: #e0e0e0;
          margin-bottom: 25px;
          max-width: 400px;
        }

        .notcool-btn {
          background: #f5c518;
          color: #000;
          border: none;
          padding: 12px 25px;
          border-radius: 30px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 0 10px rgba(245, 197, 24, 0.6);
          transition: background 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
        }

        .notcool-btn:hover {
          background: #ffdb4d;
          transform: translateY(-3px);
          box-shadow: 0 0 15px rgba(245, 197, 24, 0.9);
        }
          
        @media (max-width: 600px) {
          .notcool-container h1 {
            font-size: 1.6rem;
          }
          .notcool-container p {
            font-size: 1rem;
          }
          .notcool-btn {
            width: 80%;
            max-width: 300px;
          }
        }
      `}</style>
    </div>
  );
}
